/**
 * Keys of InlineSessionImage's module-level blob and object-URL cache: one
 * slot per scope, filename and fetched buffer (`<scope>::<filename>#<id>`).
 */

/** The cache key for one fetched buffer of one file. */
export function sessionImageCacheKey(scope: string, filename: string, bufferId: number): string {
  return `${scope}::${filename}#${bufferId}`
}

/**
 * Whether `key` is another buffer of the same file as `cacheKey` (an earlier
 * fetch of it), so it may be evicted when `cacheKey` is filled. A different
 * file whose name merely starts with this one's name and a `#` (`plot` and
 * `plot#2.png`) is not: the remainder after the shared prefix must be the
 * numeric buffer id alone.
 */
export function isOtherBufferOfSameFile(cacheKey: string, key: string): boolean {
  if (key === cacheKey) return false
  const prefix = cacheKey.slice(0, cacheKey.lastIndexOf("#") + 1)
  return key.startsWith(prefix) && /^\d+$/.test(key.slice(prefix.length))
}
